/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droplinkclear2Inputs */

const en_droplinkclear2 = /** @type {(inputs: Droplinkclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove link`)
};

const de_droplinkclear2 = /** @type {(inputs: Droplinkclear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfung entfernen`)
};

/**
* | output |
* | --- |
* | "Remove link" |
*
* @param {Droplinkclear2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droplinkclear2 = /** @type {((inputs?: Droplinkclear2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droplinkclear2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droplinkclear2(inputs)
	return de_droplinkclear2(inputs)
});
export { droplinkclear2 as "dropLinkClear" }